import { c as _c } from "react/compiler-runtime";
import { closeCurrentDialog, showNotification } from 'platform/components';
import { useHttpCalls } from '../../../api/useHttpCalls';
import type { SharePresetToUseRequestBody } from '../../../types/Api';
export const useSharePresetToUser = (presetId, gridCode) => {
  const $ = _c(5);
  let t0;
  if ($[0] !== gridCode) {
    t0 = {
      gridCode
    };
    $[0] = gridCode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    sharePresetToUser
  } = useHttpCalls(t0);
  let t1;
  if ($[2] !== presetId || $[3] !== sharePresetToUser) {
    const onSubmit = values => sharePresetToUser(presetId, values).then(_temp).catch(_temp2);
    t1 = {
      onSubmit
    };
    $[2] = presetId;
    $[3] = sharePresetToUser;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
function _temp() {
  showNotification.success();
  closeCurrentDialog();
}
function _temp2() {
  return showNotification.error();
}